<template>
  <div class="contentBox">
    <navBox :id="navId" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader></myHeader>
      <div class="searchBox">
        <div class="search-item">
          <p>会员名称：</p>
          <input type="text" placeholder="请输入会员名称" v-model="obj.title">
        </div>
        <div class="search-item">
          <p>排序：</p>
          <select v-model="obj.sort">
            <option value="asc">升序</option>
            <option value="desc">降序</option>
          </select>
        </div>
        <div class="search-item">
          <p>状态：</p>
          <select v-model="obj.status">
            <option :value="item.id" v-for="item in statusList" v-bind:key="item.id">{{item.title}}</option>
          </select>
        </div>
        <div class="search-item">
          <p>创建时间：</p>
          <select v-model="obj.create_time">
            <option value="asc">升序</option>
            <option value="desc">降序</option>
          </select>
        </div>
        <div class="btnBox">
          <button class="btn btn-search" @click="searchSub">搜索</button>
          <button class="btn btn-reset" @click="resetSub">重置</button>
        </div>
      </div>
      <div class="organiza-txt">
        <div class="organiza-title clear">
          <p>会员列表</p>
          <div class="btnBox">
            <button class="btn btn-add" @click="addShow">添加会员</button>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.name">{{item.name}}</p>
              <p :title="item.price">{{item.price}}</p>
              <p :title="item.vip_time">{{item.vip_time}}</p>
              <p :title="item.status?'开启':'未开启'">
                {{item.status?'开启':'未开启'}}
                <!-- <el-switch
                  @change="switchChange(item)"
                  v-model="item.status"
                  active-color="#457AFF"
                  inactive-color="#CBCBCB">
                </el-switch> -->
              </p>
              <p :title="item.sort">{{item.sort}}</p>
              <p :title="item.mode==1?'会员页':'收银台'">{{item.mode==1?'会员页':'收银台'}}</p>
              <p :title="item.create_time">{{item.create_time}}</p>
              <p style="color:#FF7543;">
                  <span @click="editShow(item)">编辑</span>
                  <span @click="removeSub(item)">删除</span>
              </p>
            </div>
          </div>
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>
    </div>

    <!-- 添加or编辑提示框 -->
    <div class="msgBox tipsBox" v-if="showType">
      <div class="contv">
        <p class="title">{{showType=='add'?'添加会员':'编辑会员'}}</p>
        <form>
          <div class="write-txt">
            <p>会员名称：</p>
            <input type="text" v-model="addObj.name">
          </div>
          <div class="write-txt">
            <p>设备类型：</p>
            <el-radio-group v-model="addObj.type">
              <el-radio label="1">苹果</el-radio>
              <el-radio label="2">安卓</el-radio>
              <el-radio label="3">后台</el-radio>
            </el-radio-group>
          </div>
          <div class="write-txt">
            <p>会员有效期：</p>
            <input type="number" v-model="addObj.vip_time" style="width: 50px;padding: 0 10px;">
            <el-radio-group v-model="vip_date">
              <el-radio label="d">天</el-radio>
              <el-radio label="m">月</el-radio>
              <el-radio label="y">年</el-radio>
            </el-radio-group>
          </div>
          <div class="write-txt">
            <p>价格：</p>
            <input type="number" v-model="addObj.price">
          </div>
          <div class="write-txt">
            <p>单价：</p>
            <input type="number" v-model="addObj.unit_price">
            <span>{{addObj.type==1?'周':'天'}}</span>
          </div>
          <div class="write-txt">
            <p>折扣：</p>
            <input type="text" v-model="addObj.discount">
          </div>
          <div class="write-txt">
            <p>选择题库包：</p>
            <select v-model="addObj.qpid" @change="bankSub" :disabled="showType=='edit'">
              <option value="">请选择</option>
              <option :value="item.qpid" v-for="(item,index) in bankList" :key="index">{{item.name}}</option>
            </select>
          </div>
          <div class="write-txt">
            <p>模式：</p>
            <select v-model="addObj.mode" :disabled="showType=='edit'">
              <option value="">请选择</option>
              <option value="1">会员页</option>
              <option value="2">收银台</option>
            </select>
          </div>
          <div class="write-txt">
            <p>排序：</p>
            <select v-model="addObj.sort" @change="sortSub" :disabled="showType=='edit'">
              <option value="">请选择</option>
              <option :value="item" v-for="(item,index) in 10" :key="index">{{item}}</option>
            </select>
            <!-- <input type="number" v-model="addObj.sort"> -->
          </div>
          <div class="write-list">
            <div class="write-txt">
              <p>关联模拟卷：</p>
              <el-select v-model="addObj.tids" multiple placeholder="请选择" @change="$forceUpdate()" disabled>
                <el-option
                  v-for="item in testList"
                  :key="item.tid"
                  :label="item.name"
                  :value="item.tid">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="write-txt">
            <p>状态：</p>
            <el-switch
              v-model="addObj.status"
              active-color="#4C7EFB"
              inactive-color="#ccc">
            </el-switch>
          </div>
          <div class="write-txt">
            <p>是否默认选中：</p>
            <el-radio-group v-model="addObj.is_selected">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
          <div class="write-txt" v-if="addObj.type==1">
            <p>连续订阅：</p>
            <select v-model="addObj.bind_id" :disabled="showType=='edit'">
              <option value="">请选择</option>
              <option :value="item.id" v-for="(item,index) in vipList" :key="index">{{item.name}}</option>
            </select>
          </div>
        </form>
        <div class="btnBox">
          <button class="btn btn-sub" @click="addSub">确认</button>
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
import { getMockTestVipList,getQuebankPackageFastList,saveMockTestVip,getTestFastList,getMockTestVipDetail,delMockTestVip,getMockTestVipAllList } from "@/assets/js/api";
export default {
  name: "exam",
  data() {
    return {
      navId:'4',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'会员名称'},
        {id:3,title:'设备类型'},
        {id:4,title:'价格'},
        {id:5,title:'有效期'},
        {id:6,title:'状态'},
        {id:7,title:'排序'},
        {id:8,title:'模式'},
        {id:9,title:'创建时间'},
        {id:10,title:'操作'},
      ],
      dataList:[],
      showType:'',
      token:'',
      obj:{
        page:1,
        rows:10,
        status:9,
        sort:'asc',
        create_time:'asc'
      },
      addObj:{
        name:'',
        type:'',
        price:'',
        qpid:'',
        tids:[],
        vip_time:'',
        sort:'',
        status:false,
        bind_id:0
      },
      totalPage:0,
      userData:{
        authority:[],
      },
      statusList:[
        {id:9,title:'全部'},
        {id:1,title:'开启'},
        {id:0,title:'未开启'},
      ],
      bankList:[],
      testList:[],
      vip_date:'d',
      vipList:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.userData = this.$refs.navBox.userData
    this.token =this.userData.token;
    this.getList();
    this.getVipList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },

    // 取消
    closeSub(){
      this.addObj={
        name:'',
        type:'',
        price:'',
        qpid:'',
        tids:[],
        vip_time:'',
        sort:'',
        status:false,
        bind_id:0
      };
      this.showType = '';
    },

    // 确认添加or编辑
    addSub(){
      var that = this;
      if(this.addObj.name == ''){
        that.$message('请输入会员名称');
        return false;
      } else if(this.addObj.type == ''){
        that.$message('请选择设备类型');
        return false;
      } else if(this.addObj.price == ''){
        that.$message('请输入价格');
        return false;
      } else if(this.addObj.qpid == ''){
        that.$message('请选择题库包');
        return false;
      } else if(this.addObj.sort == ''){
        that.$message('请选择排序');
        return false;
      } else if(this.addObj.vip_time == ''){
        that.$message('请输入会员有效期');
        return false;
      }
      this.addObj.status = this.addObj.status ? 1 : 0;
      this.addObj.vip_time = this.addObj.vip_time + this.vip_date;
      // if(this.addObj.type == 2){
      //   this.addObj.bind_id = 0;
      // };

      saveMockTestVip(that.addObj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
        }
      })
    },

    // 搜索
    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    // 重置
    resetSub(){
      this.obj.page = 1;
      if(this.obj.title){
        delete this.obj.title;
      };
      this.addObj={
        name:'',
        type:'',
        price:'',
        qpid:'',
        tids:[],
        vip_time:'',
        sort:'',
        status:'',
      };
      this.obj = {
        page:1,
        rows:10,
        status:9,
        sort:'asc',
        create_time:'asc'
      }
      this.dataList = [];
      this.getList();
      
    },

    getList(){
      var that = this;
      getMockTestVipList(this.obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          data.data.list.forEach(function(item,index){
            if(item.status == 1){
              item.status = true;
            } else {
              item.status = false;
            }
          });
          that.dataList = data.data.list;
          that.totalPage = data.data.total_page;
        } else {
          that.$message(data.msg);
        }
      })
    },

    addShow(){
      this.showType = 'add';
      this.getBank();
    },

    bankSub(){
      this.testList = [];
      this.addObj.sort = '';
      this.addObj.tids = [];
      this.getTest();
      this.selectSub();
    },

    sortSub(){
      this.addObj.tids = [];
      this.selectSub();
    },

    selectSub(){
      var that = this;
      if(this.addObj.sort == ''){
        return false;
      }
      if(this.testList.length == 0){
        that.$message('当前题库包暂无试卷！');
        return false;
      }
      if(this.addObj.sort == 1){
        this.addObj.tids.push(this.testList[0].tid);
      } else {
        if(this.testList.length < 10){
          that.$message('当前试卷数量不够');
          this.addObj.tids = [];
          return false;
        } else {
          var list = this.testList;
          var tidList = [];
          list.forEach(function(item,index){
            if(index < (that.addObj.sort-1)*10){
              that.addObj.tids.push(item.tid);
            }
          })
        }
      }
    },

    getBank(){
      var that = this;
      getQuebankPackageFastList(this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.bankList = res.data.data;
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },

    getTest(){
      var that = this;
      getTestFastList({qpid:this.addObj.qpid},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.testList = res.data.data;
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    }, 

    editShow(e){
      var that = this;
      this.getBank();
      getMockTestVipDetail({id:e.id},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.showType = 'edit';
          res.data.data.type = `${res.data.data.type}`;
          res.data.data.status = res.data.data.status==1 ? true : false;
          var time = res.data.data.vip_time.split('');
          var dateList = ['d','m','y'];
          if(res.data.data.vip_time.indexOf('d') > -1){
            res.data.data.vip_time = res.data.data.vip_time.replace(/d/g,"");
          } 
          if(res.data.data.vip_time.indexOf('m') > -1){
            res.data.data.vip_time = res.data.data.vip_time.replace(/m/g,"");
          } 
          if(res.data.data.vip_time.indexOf('y') > -1){
            res.data.data.vip_time = res.data.data.vip_time.replace(/y/g,"");
          } 
          console.log(res.data.data.vip_time);
          // res.data.data.vip_time = time[0];
          that.vip_date = time[time.length-1];
          that.addObj = res.data.data;
          that.addObj.id = e.id;
          that.addObj.is_selected = JSON.stringify(e.is_selected);
          console.log(that.addObj,'==addd==');
          that.getTest();
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },

    removeSub(e){
      var that = this;
      delMockTestVip({id:e.id},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('成功!');
          that.showType = '';
          that.resetSub();
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
      
    }, 

    switchChange(e){
      var that = this;
      var obj = {
        mtid:e.mtid,
        status:e.publish_status==false?0:1,
      };
      publishMockTest(obj,this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.$message('发布状态修改成功！');
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    },

    topicSub(e){
      var that = this;
      console.log(e.mtid)
      that.$router.push('/pack?id='+e.mtid);
    },

    lookStudent(e){
      var that = this;
      that.$router.push('/parent');
    },

    getVipList(){
      var that = this;
      getMockTestVipAllList({type:1},this.token).then((res)=>{
        var data = res.data;
        if(data.code == 200){
          that.vipList = data.data;
        } else {
          that.$message(data.msg);
          e.publish_status = !e.publish_status;
        }
      })
    }
  },
};
</script>
<style scoped>
.dataList .listItem p,
.organiza-list p{
  width: calc( 100% / 10 );
}

.el-switch,
.el-radio-group{
  height: 36px;
  width: 225px;
}

.el-radio{
  line-height: 36px;
}

.el-radio__label{
  font-size: 15px;
}
.tipsBox form .write-txt span{
  height: 36px;
  line-height: 36px;
  font-size: 15px;
  color: #3D3D3D;
  display: inline-block;
  vertical-align: top;
}
.tipsBox form .write-txt p{
  width: 150px;
}
.tipsBox .contv{
  height: 80%;
}
.tipsBox form{
  height: 80%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/vip/list.vue